import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ohc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const u = cfg.url || "";
  const gate = u.startsWith("/consultation-charges") ? "consultation" : (u.startsWith("/incentive") || u.startsWith("/revenue")) ? "incentives" : null;
  const gt = gate && sessionStorage.getItem(`ohc_gate_${gate}`);
  if (gt) cfg.headers["X-Gate-Token"] = gt;
  return cfg;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
const shownWarn = {};
api.interceptors.response.use((r) => {
  const w = r.data && !Array.isArray(r.data) && Array.isArray(r.data.warnings) ? r.data.warnings : [];
  w.forEach((m) => {
    if (shownWarn[m] && Date.now() - shownWarn[m] < 4000) return;
    shownWarn[m] = Date.now();
    import("sonner").then(({ toast }) => toast.warning(m, { duration: 9000 }));
  });
  return r;
}, (err) => {
  if (err.response?.status === 423) {
    ["consultation", "incentives"].forEach((g) => sessionStorage.removeItem(`ohc_gate_${g}`));
    window.dispatchEvent(new Event("ohc-gate-locked"));
  }
  return Promise.reject(err);
});

export default api;
